import React from 'react';
import MultiRateChooser from 'common/spot-details/multi-rate-select';
const ParkingOptions = ({ availableRates, selectedRate, onMultiRateChange, }) => {
    return (<div className="ParkingOptions">
            <h3 className="ParkingOptions-header">Parking Options</h3>
            <MultiRateChooser selectedRate={selectedRate} rates={availableRates} onMultiRateChange={onMultiRateChange}/>
        </div>);
};
export default ParkingOptions;
